(() => {
  const initSlider = (root) => {
    const track = root.querySelector('[data-lp2-slider-track]');
    const dots = [...root.querySelectorAll('[data-lp2-slide-dot]')];
    if (!track || !dots.length) return;

    const slides = [...track.children];
    const update = () => {
      const left = track.scrollLeft;
      const nearest = slides.reduce((best, slide, index) => {
        const distance = Math.abs(slide.offsetLeft - left);
        return distance < best.distance ? { index, distance } : best;
      }, { index: 0, distance: Infinity }).index;
      dots.forEach((dot, index) => dot.classList.toggle('is-active', index === nearest));
    };

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => slides[index]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' }));
    });
    track.addEventListener('scroll', update, { passive: true });
    update();
  };

  const initCountdown = (root) => {
    const hours = root.querySelector('[data-lp2-hours]');
    const minutes = root.querySelector('[data-lp2-minutes]');
    const seconds = root.querySelector('[data-lp2-seconds]');
    if (!hours || !minutes || !seconds) return;
    const key = 'lp2-countdown-end';
    let end = Number(sessionStorage.getItem(key));
    if (!end || end <= Date.now()) {
      end = Date.now() + (53 * 60 + 5) * 1000;
      sessionStorage.setItem(key, String(end));
    }
    const render = () => {
      const remaining = Math.max(0, end - Date.now());
      hours.textContent = String(Math.floor(remaining / 3600000)).padStart(2, '0');
      minutes.textContent = String(Math.floor((remaining % 3600000) / 60000)).padStart(2, '0');
      seconds.textContent = String(Math.floor((remaining % 60000) / 1000)).padStart(2, '0');
    };
    render();
    window.setInterval(render, 1000);
  };

  document.querySelectorAll('[data-lp2-slider]').forEach(initSlider);
  document.querySelectorAll('[data-lp2-countdown]').forEach(initCountdown);
})();
